
import React, { Component } from 'react';
import { Button, Box, Image, Layer, Markdown, Text } from 'grommet';
import { FormClose, FormNext, FormPrevious } from 'grommet-icons';
import removeMd from 'remove-markdown';

const CloseButton = ({onClose}) => {
    return (
        <Button
            primary
            label="Zavřít"
            onClick={() => {
                if (onClose) {
                    onClose();
                }
            }}
        />
    );
}

const LayerWithImage = ({galleryTitle, images, imageIndex, onClose, onPrevious, onNext}) => {
    let image = images[imageIndex];
    return (
        <Layer full onEsc={onClose} >
            <Box fill background="dark-4" align="center" justify="between" pad={{bottom: "large"}} gap="small">
                <Box direction="row" align="center" fill="horizontal">
                    <Box width="72px"></Box>
                    <Box flex="grow" align="center">
                        <Text color="dark-1">{galleryTitle}</Text>
                    </Box>
                    <Button icon={<FormClose size="large" onClick={onClose} />} title="Zavřít" />
                </Box>
                <Box align="center">
                    <Box direction="row">
                        <Box direction="row" width="72px">
                            {(imageIndex > 0)
                                ? <Button icon={<FormPrevious size="large" onClick={onPrevious} />} title="Přejít na předchozí fotografii" />
                                : null
                            }
                        </Box>
                        <Image src={`/api/img/${image.fileName}/full`} fit="contain" />
                        <Box direction="row" width="72px">
                            {(imageIndex < (images.length - 1))
                                ? <Button icon={<FormNext size="large" onClick={onNext} />} title="Přejít na následující fotografii" />
                                : null
                            }
                        </Box>
                    </Box>
                    <Markdown color="dark-1">{image.title}</Markdown>
                </Box>
                <CloseButton onClose={onClose} />
            </Box>
        </Layer>
    );
}

const ImagePreview = ({onClick, fileName, title, type}) => {
    return (
        <Box pad="small">
            <Box>
                <Button plain={true} onClick={onClick} >
                    <Image src={`/api/img/${fileName}/${type}`} fit="contain" title={removeMd(title)} />
                </Button>
            </Box>
        </Box>
    );
}

class ImagesPreviewPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showFull: false,
            imageIndex: -1
        };
    }

    handleOnClick = (imageIndex) => {
        this.setState({
            showFull: true,
            imageIndex: imageIndex
        });
    }

    handleOnChangeImageIndex = (change) => {
        let newImageIndex = this.state.imageIndex + change;
        if ((newImageIndex >= 0) && (newImageIndex < this.props.images.length)) {
            this.setState({
                imageIndex: newImageIndex
            });
        }
    }

    handleOnNext = () => {
        this.handleOnChangeImageIndex(1);
    }

    handleOnPrevious = () => {
        this.handleOnChangeImageIndex(-1);
    }

    handleOnClose = () => {
        this.setState({showFull: false});
    }

    render() {
        return (
            <Box>
                <Box direction="row" wrap={true} justify="center">
                    {this.props.images.map((item, index) => {
                        return (
                            <ImagePreview
                                key={item.fileName}
                                fileName={item.fileName}
                                type={item.type}
                                title={item.title}
                                onClick={this.handleOnClick.bind(this, index)}
                            />
                        );
                    })}
                </Box>
                {this.state.showFull && (
                    <LayerWithImage
                        galleryTitle={this.props.galleryTitle}
                        images={this.props.images}
                        imageIndex={this.state.imageIndex}
                        onClose={this.handleOnClose}
                        onPrevious={this.handleOnPrevious}
                        onNext={this.handleOnNext}
            />
                )}
            </Box>
        );
    }
}

export default ImagesPreviewPanel;
